import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { scrollToTop } from 'lib/scrollToTop';

const ScrollToTop = ({ children }) => {
    const { pathname } = useLocation();

    // With the default 'auto', the browser restores the saved offset on back/forward
    // after this reset runs, against a page that is still loading, so it lands mid-page.
    useLayoutEffect(() => {
        if ('scrollRestoration' in window.history) {
            window.history.scrollRestoration = 'manual';
        }
    }, []);

    useLayoutEffect(() => {
        scrollToTop();
    }, [pathname]);

    return children || null;
};

ScrollToTop.propTypes = {
    children: PropTypes.node,
};

export default ScrollToTop;
